import React from 'react'
import { Tab, Tabs as RTabs, TabList, TabPanel } from 'react-tabs'
import styles from './Tabs.module.scss'
import { $TSFixMe } from 'types/ts-migrate'

interface IProps {
  heading?: string
  setShowRequiredFieldsInfo?: boolean
  tabs: Array<{
    title: string
    content: $TSFixMe
  }>
  selectedTab?: number
  onTabChange?: (index: number, lastIndex: number, event: $TSFixMe) => void
}

const Tabs = ({ heading, setShowRequiredFieldsInfo = false, tabs, selectedTab, onTabChange }: IProps) => {
  return (
    <div className={styles.root}>
      {heading && <span className={styles.heading}>{heading}</span>}
      <RTabs onSelect={onTabChange} selectedIndex={selectedTab}>
        <TabList>
          {tabs.map((tab, i) => (
            <Tab key={i}>{tab.title}</Tab>
          ))}
        </TabList>
        {setShowRequiredFieldsInfo && (
          <div className={styles['required-fields-info']}>
            Fields marked with <span>*</span> are required.
          </div>
        )}
        {tabs.map((tab, i) => (
          <TabPanel key={i}>{tab.content}</TabPanel>
        ))}
      </RTabs>
    </div>
  )
}

export default Tabs
